<template>
  <div class="checkBox_head ">
    <div class="search">
      <span class="current_tit">当前区域：</span>
      <div class="margin-right_20">
        <span>{{location.site}}</span>
        <span v-if="location.site">附近{{toThousands}}以内园区</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  name: 'mapHeadCheckBox',
  data () {
    return {
    }
  },
  props: {
    location: {
      type: Object,
      default: () => ({ site: null, latitude: null, longtitude: null, distance: 0 })
    }
  },
  computed: {
    toThousands () {
      let num = this.location.distance
      num = (num / 1000)
      if (num > 1) {
        num = parseInt(num)
        num = (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        return num + 'KM'
      } else {
        num = parseInt(num * 1000)
        num = (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        return num + 'M'
      }
    }

  },
  mounted () {
  },
  watch: {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.checkBox_head {
  position: relative;
  .search {
    width: 80%;
    min-width: 600px;
    display: flex;
    line-height: 14px;
    padding: 8px 0 13px 0px;
    box-sizing: border-box;
    > span {
      flex-grow: 0;
      flex-shrink: 0;
      color: #999999;
      margin-right: 8px;
      font-size: 13px;
      margin-top: 1px;
    }
    > div {
      flex-grow: 1;
      flex-shrink: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      span{
        font-size: 13px;
      }
    }
  }
}

</style>
